import React, { useEffect, useState } from "react";
import { HiChevronRight, HiOutlineSearch } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../redux/slices/orderSlice";
import { IoEyeOutline } from "react-icons/io5";
import {
  // convertValue,
  formatCreatedAt,
  formatNumberWithCommas,
  formatTime,
} from "../../utils/commonUtils";
import { ImSpinner2 } from "react-icons/im";
import { fetchUsers } from "../../redux/slices/userSlice";
import CancelOrderPayOnDelivery from "../../components/modals/cancel/CancelOrderPayOnDelivery";

// import { ImSpinner2 } from "react-icons/im";

const OrderPayonDelivery = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchOrders());

    dispatch(fetchUsers());
  }, [dispatch]);

  const orders = useSelector((state) => state.order?.orders);

  const usersList = useSelector((state) => state.user?.users);

  const filteredPayonDelivery = orders.filter((order) => {
    return order.pay_on_delivery === "1" && order.status !== "completed";
  });

  // console.log(filteredPayonDelivery)

  // Filter categories based on search term
  const filteredPayonDeliveries = filteredPayonDelivery.filter(
    (order) =>
      search.toLowerCase() === "" ||
      order.username.toLowerCase().includes(search) ||
      order.order_id.toString().toLowerCase().includes(search)
  );

  // Calculate the index of the first and last item to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentPayonDeliveries = filteredPayonDeliveries.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredPayonDeliveries.length / itemsPerPage);

  // Function to handle pagination
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const status = useSelector((state) => state.order?.status);
  const error = useSelector((state) => state.order?.error);

  const getUserNameFromId = (userId) => {
    const user = usersList?.find((user) => user.id === parseInt(userId, 10));
    if (!user) {
      return { name: "Unknown", email: "N/A", phone: "N/A" };
    }

    return {
      name: `${user.firstname} ${user.lastname}`,
      email: user.email,
      phone: user.phone,
    };
  };

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="w-full h-auto text-2xl mb-2 text-[#333843] font-medium">
            Pay on Delivery
          </h1>

          <div className="flex mb-4 justify-center items-center gap-2 mt-4">
            <Link to="/dashboard">
              <p className="text-[14px] text-[#1F7BF4] font-medium hover:underline">
                Dashboard
              </p>
            </Link>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#1F7BF4]  font-medium">Shopping</p>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#667085] font-medium">
              Pay On Delivery
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-between mb-4">
        <button className="relative w-72">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <HiOutlineSearch className=" text-gray-500 text-2xl" />
          </div>
          <input
            type="text"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
            placeholder="Search orders..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </button>
      </div>

      <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left whitespace-nowrap text-gray-500">
            <thead className="text-sm text-gray-700 bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-center">No.</th>
                <th className="px-4 py-4 text-center">Date</th>
                <th className="px-2 py-3 text-left">Customer</th>
                <th className="px-2 py-3 text-center">Order Id</th>
                <th className="px-2 py-3 text-center ">Amount</th>
                <th className="px-2 py-3 text-center ">Receipt</th>
                <th className="px-2 py-3 text-center ">Status</th>
                <th className="px-2 py-3 text-center">Delivery Date</th>
                <th className="px-2 py-3 text-center">Delivery Time</th>
                <th className="px-2 py-3 text-center">Updated</th>
                <th className="px-2 py-3 text-center">Cancel Order</th>
                <th className="px-2 py-3 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="text-sm text-left">
              {status === "failed" ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      Error. {error}.{" "}
                      <span className="text-base font-semibold ">
                        {" "}
                        Try again later
                      </span>
                    </div>
                  </td>
                </tr>
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      <ImSpinner2 className="animate-spin h-8 w-8 text-gray-500" />
                    </div>
                  </td>
                </tr>
              ) : currentPayonDeliveries.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center text-gray-500 py-4">
                    No Data
                  </td>
                </tr>
              ) : (
                currentPayonDeliveries?.map((order, index) => (
                  <tr key={order.id}>
                    <td className="px-4 py-4">
                      <p className=" text-base  font-semibold">
                        {indexOfFirstItem + index + 1}
                      </p>
                    </td>
                    <td className="px-4 py-4 text-center">
                      {formatCreatedAt(order.created_at)}
                    </td>
                    <td className="px-4 py-4 text-left">
                      <Link
                        to={`/dashboard/orders/pay-on-delivery/user/${order.user_id}`}
                      >
                        <div className="flex flex-col gap-2 cursor-pointer">
                          <p className=" text-base font-semibold text-blue-600">
                            {getUserNameFromId(order.user_id).name}
                          </p>
                          <p>{getUserNameFromId(order.user_id).phone}</p>
                          <p>{getUserNameFromId(order.user_id).email}</p>
                        </div>
                      </Link>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap">
                      <Link
                        to={`/dashboard/orders/pay-on-delivery/${order.order_id}`}
                      >
                        <p className="px-4 py-1 text-base text-center font-semibold text-blue-600">
                          {order.order_id}
                        </p>
                      </Link>
                    </td>

                    <td className="px-4 py-2 text-center">
                      <span className="mr-1">&#8358;</span>
                      {formatNumberWithCommas(
                        order.total_amount ? order.total_amount : 0
                      )}
                    </td>
                    <td className="px-2 py-2">
                      <div className="flex items-center p-2 justify-center">
                        {order.receipt ? (
                          <img
                            src={order.receipt}
                            alt="receipt"
                            className="w-24 h-24 object-cover rounded-lg"
                          />
                        ) : (
                          " No Receipt"
                        )}
                      </div>
                    </td>
                    <td className="px-2 py-2 text-center whitespace-nowrap">
                      {order.status}
                    </td>

                    <td className="px-2 py-2 text-center whitespace-nowrap">
                      {formatCreatedAt(order.delivery_date)}
                    </td>
                    <td className="px-2 py-2 text-center whitespace-nowrap">
                      {formatTime(order.delivery_date)}
                    </td>
                    <td className="px-2 py-2 text-center whitespace-nowrap">
                      {formatCreatedAt(order.updated_at)}
                    </td>
                    <td className="px-2 py-4">
                      <div className="flex gap-4 justify-center">
                        <CancelOrderPayOnDelivery
                          user_id={order.user_id}
                          orderId={order.order_id}
                          name={order.customer.name}
                        />
                      </div>
                    </td>
                    <td className="px-2 py-2">
                      <div className="flex gap-4 justify-center">
                        <div>
                          <Link
                            to={`/dashboard/orders/pay-on-delivery/${order.order_id}`}
                          >
                            <IoEyeOutline className="text-base text-[#667085]" />
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between px-[24px] py-[15px] items-center">
          <p className="text-[14px] py-4 font-medium text-[#667085] tracking-[0.07px]">
            Showing {indexOfFirstItem + 1} - {indexOfLastItem} from{" "}
            {filteredPayonDelivery.length}
          </p>

          <div className="flex gap-[8px]">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Previous
            </button>

            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPayonDelivery;
